import { useEffect, useState } from "react";
import type { GeoLocation } from "@budgeter/shared";

/**
 * The device's position, asked for once when enabled (the browser asks permission the first
 * time). Never blocks: until a fix arrives, or if it's refused, this is null.
 */
export function useCurrentLocation(enabled: boolean): GeoLocation | null {
  const [here, setHere] = useState<GeoLocation | null>(null);
  useEffect(() => {
    if (!enabled || typeof navigator === "undefined" || !navigator.geolocation) {
      return;
    }
    let live = true;
    try {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (live) {
            setHere({ lat: pos.coords.latitude, lng: pos.coords.longitude });
          }
        },
        () => {
          // Refused or unavailable: Quick Add works the same without a guess.
        },
        { enableHighAccuracy: true, timeout: 20_000, maximumAge: 60_000 },
      );
    } catch {
      // Some embedded browsers throw instead of calling the error callback.
    }
    return () => {
      live = false;
    };
  }, [enabled]);
  return enabled ? here : null;
}
